import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Non-blocking banner shown when the user's session has expired.
 * Preserves current page state — doesn't redirect.
 */
export default function SessionExpiryBanner() {
  const { sessionExpired, clearSessionExpired } = useAuth();

  if (!sessionExpired) return null;

  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-3" role="alert">
      <div className="container-main flex items-center justify-between gap-4">
        <p className="text-sm text-amber-900">
          Your session has expired.{' '}
          <Link
            to="/login"
            state={{ returnTo: window.location.pathname + window.location.search }}
            className="font-semibold text-amber-900 underline hover:text-amber-800"
          >
            Sign in again
          </Link>{' '}
          to continue.
        </p>
        <button
          onClick={clearSessionExpired}
          className="text-amber-700 hover:text-amber-900 flex-shrink-0"
          aria-label="Dismiss session expiry notice"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
